import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Alshallal input — HeroUI field style.
 * Field surface is `--bg-surface-2` (subtle cream) for depth on cards,
 * transparent border by default, brand-orange border on focus, no shadow.
 * Height 9 (36px) matches HeroUI's md scale.
 */
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        // base
        "flex h-9 w-full rounded-[var(--radius-sm)] px-3 py-1 text-sm",
        "bg-[color:var(--bg-surface-2)] text-[color:var(--ink)]",
        "border border-transparent",
        "placeholder:text-[color:var(--ink-faint)]",
        // motion
        "transition-[background-color,border-color,box-shadow] duration-150",
        // hover / focus
        "hover:bg-[color:color-mix(in_oklab,var(--bg-surface-2)_92%,var(--ink)_8%)]",
        "focus-visible:outline-none focus-visible:border-[color:var(--brand-orange)] focus-visible:bg-[color:var(--bg-surface)]",
        // file input tweak (uploads)
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[color:var(--ink)]",
        // disabled
        "disabled:cursor-not-allowed disabled:opacity-50",
        // mobile
        "md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
